import React, {useEffect, useRef, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {Label} from './Label'

import {Props as InputProps} from './Input'

type Props = InputProps & {
  id: string
}

export const FileInput = ({
  className,
  id,
  name,
  label,
  info = '',
  placeholder = 'Select a file ...',
  icon = (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      width="16"
      height="16"
      className="fill-gray-600">
      <path d="M850,974.5H150c-77.3,0-140-65.3-140-145.9V646.3c0-20.1,15.7-36.5,35-36.5h70c19.3,0,35,16.3,35,36.5v109.4c0,40.3,31.3,72.9,70,72.9h560c38.7,0,70-32.7,70-72.9V646.3c0-20.1,15.7-36.5,35-36.5h70c19.3,0,35,16.3,35,36.5v182.3C990,909.2,927.3,974.5,850,974.5L850,974.5z M784.5,449.2c-14.2,14.8-37.1,14.8-51.3,0L570,279.1v367.2c0,20.1-15.7,36.5-35,36.5h-70c-19.3,0-35-16.3-35-36.5V279.1L266.8,449.2c-14.2,14.8-37.1,14.8-51.3,0l-51.3-53.4c-14.2-14.8-14.2-38.7,0-53.4L453.2,41.1c1.2-1.3,23.7-15.6,46.4-15.6c22.9,0,45.9,14.3,47.2,15.6l289.1,301.2c14.2,14.8,14.2,38.7,0,53.4L784.5,449.2L784.5,449.2z" />
    </svg>
  ),
  onChange,
  autocomplete = 'on',
  disabled,
}: Props) => {
  const {
    setValue,
    register,
    formState: {errors},
  } = useFormContext() || {}
  const error = errors[name] as any
  const ref = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState(null)
  const iconClasses = !!icon && `pr-10`

  const handleOnChange = e => {
    setFile(null)
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onloadend = () => setFile(reader.result.toString())
    reader.readAsDataURL(file)
    const element = e.target as HTMLInputElement
    element.value = ''
  }

  useEffect(() => {
    if (onChange) onChange(file)
    setValue(name, file)
    //eslint-disable-next-line
  }, [file])

  return (
    <React.Fragment>
      {label && (
        <Label
          className="font-semibold"
          htmlFor={name}
          label={label}
          info={info}
        />
      )}
      <div className="relative text-form-icon focus-within:text-focus-icon relative overflow-hidden">
        <input
          id={id}
          type="file"
          placeholder={placeholder}
          className="invisible absolute -mt-[30px]"
          onChange={handleOnChange}
          autoComplete={autocomplete}
          disabled={disabled}
        />
        <input ref={ref} type="hidden" {...(name ? register(name) : {})} />
        <label
          htmlFor={id}
          className={`border rounded p-2 w-full 
             focus:outline-none font-form
             text-form 
             border-form-border
             placeholder-form-placeholder
             focus:text-focus 
             focus:border-focus-border 
             focus:placeholder-focus-placeholder
             text-sm
             block cursor-pointer
             pl-14
              ${className}
             ${iconClasses}
            `}
          onClick={() => {
            ;(document.getElementById(id) as HTMLInputElement).value = null
          }}>
          {placeholder}
        </label>
        <div className="customIcon rounded-l absolute inset-y-0 left-0 px-3 flex items-center bg-gray-200 border-r">
          {icon}
        </div>
      </div>
      {error && <p className="text-alert pt-1.5 text-xs">{error.message}</p>}
    </React.Fragment>
  )
}
